import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface BodyStyleModel {
  id?: number;
  style?: string;
  english?: string;
  dutch?: string;
  german?: string;
  french?: string;
  spanish?: string;
  portugues?: string;
  italian?: string;
  polish?: string;
  czech?: string;
  swedish?: string;
  danish?: string;
  norwegian?: string;
  finnish?: string;
  hungarian?: string;
  croatian?: string;
  hebrew?: string;
  slovene?: string;
  russian?: string;
  arabic?: string;
  ukrainian?: string;
}

class GetBodyStylesRequest {}

class GetBodyStylesResponse {
  bodyStyles?: BodyStyleModel[];
}

class CreateBodyStyleRequest {
  bodyStyleModel?: BodyStyleModel;
}

class UpdateBodyStyleRequest {
  style?: string;
  bodyStyleModel?: BodyStyleModel;
}

class DeleteBodyStyleRequest {
  style?: string;
}

export const bodyStyleApi = {
  async getBodyStyles(): Promise<Result<BodyStyleModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetBodyStylesResponse>(
        "GetBodyStyles",
        new GetBodyStylesRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.bodyStyles ?? [] };
    }

    return response;
  },

  async deleteBodyStyles(style?: string): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteBodyStyles", {
      style: style,
    } as DeleteBodyStyleRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    return response;
  },

  async createBodyStyle(bodyStyleModel: BodyStyleModel): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateBodyStyles", {
      bodyStyleModel: bodyStyleModel,
    } as CreateBodyStyleRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "BodyStyleModel");

    return response;
  },

  async updateBodyStyle(
    style?: string,
    bodyStyleModel?: BodyStyleModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateBodyStyles", {
      style: style,
      bodyStyleModel: bodyStyleModel,
    } as UpdateBodyStyleRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "BodyStyleModel");

    return response;
  },
};
